import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AchievementsConnectionOverviewResponse } from '../models/achievements';

@Injectable({
  providedIn: 'root',
})
export class AchievementsService {
  private apiUrl = environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getConnectionAchievementsOverview(): Observable<AchievementsConnectionOverviewResponse> {
    return this.http.get<AchievementsConnectionOverviewResponse>(
      `${this.apiUrl}/api/achievements`,
      { headers: { 'X-Skip-Loader': 'true' } },
    );
  }
}
